var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 215,
    viewBox: "0 0 214 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000160217 182.546H214V184.372H-0.000160217V182.546Z",
    fill: "#CECECE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000160217 151.971H214V153.797H-0.000160217V151.971Z",
    fill: "#CECECE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000160217 121.393H214V123.219H-0.000160217V121.393Z",
    fill: "#CECECE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000160217 90.8157H214V92.6416H-0.000160217V90.8157Z",
    fill: "#CECECE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000160217 60.241H214V62.0669H-0.000160217V60.241Z",
    fill: "#CECECE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000160217 29.6633H214V31.4893H-0.000160217V29.6633Z",
    fill: "#CECECE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6581 0H31.4838V214.035H29.6581V0Z",
    fill: "#CECECE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2312 0H62.0569V214.035H60.2312V0Z",
    fill: "#CECECE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8005 0H92.6261V214.035H90.8005V0Z",
    fill: "#CECECE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M121.374 0H123.199V214.035H121.374V0Z",
    fill: "#CECECE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M151.947 0H153.772V214.035H151.947V0Z",
    fill: "#CECECE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M182.516 0H184.341V214.035H182.516V0Z",
    fill: "#CECECE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4118 58.856L32.6649 58.856L32.6649 26.1039L65.4118 26.1039V58.856Z",
    fill: "#CECECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/vector-4.cdb63097d876bd6e4986c492ab7ec509.svg";
export { ForwardRef as ReactComponent };